// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"drag-move","clipPath":"url(#clip0_543_5327)"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 5L12 2L9 5M8.99999 19L12 22L15 19M19 15L22 12L19 9M5 8.99999L2 12L5 15M12 3V12M12 12V21M12 12H21M12 12H3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-drag-move')
export default class DragMoveIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'drag-move',
    }
  }
}
